import {
  Component,
  computed,
  EventEmitter,
  Output,
  Signal,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ViewResponseModel } from 'src/app/CommonFiles/BusinessModels';
import { ViewConfigGRPCService } from 'src/app/ProxyServices/view-config.grpc.service';

@Component({
  standalone: false,
  selector: 'app-views',
  templateUrl: 'views.component.html',
})
export class ViewsComponent {
  views!: Signal<ViewResponseModel[]>;
  active!: Signal<ViewResponseModel>;

  filteredViews = computed<ViewResponseModel[]>(() => {
    const active = this.active();
    const allViews = this.views();
    let views = allViews.filter(
      (view) => view.contractName === active?.contractName
    );
    // Move default to top
    return views.sort((a, b) => {
      if (a.isDefault && !b.isDefault) return -1;
      if (!a.isDefault && b.isDefault) return 1;

      // Sort title alphabetically
      return a.title.localeCompare(b.title);
    });
  });

  isNew: boolean = false;
  @Output() save: EventEmitter<boolean> = new EventEmitter();
  @Output() onSelect: EventEmitter<void> = new EventEmitter();

  constructor(private _clientViewConf: ViewConfigGRPCService) {
    this.active = toSignal(this._clientViewConf.getActiveView());
    this.views = toSignal(this._clientViewConf.asObservable(), {
      initialValue: [],
    });
  }

  delete(name: string) {
    this._clientViewConf.delete({ name: name });
  }
  select(view: ViewResponseModel) {
    const name = view.name;
    const views = this.views();
    this._clientViewConf.RXSetCurrentActiveView(name, true, views, false);
    this.onSelect.emit();
  }
  toggleAddViewDialog(isNew?: boolean) {
    this.save.emit(false);
  }
}
